export default "__VITE_ASSET__06e21ca0__"